import { PlatformShell } from '@/components/shell/PlatformShell'

export default function App() {
  return <PlatformShell />
}
